//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    steps () {
      return this.$t('how.steps')
    }
  },
  methods: {
    isIndexOdd (index) {
      return index % 2 !== 0
    }
  }
}
